const carouselTrack = document.getElementById('pack-carousel-track');
  
  if (carouselTrack) {
    const prevArrow = document.getElementById('pack-arrow-prev');
    const nextArrow = document.getElementById('pack-arrow-next');
    const thumbs = document.querySelectorAll('.pack-thumb');

    // Scroll Logic (Absolute Center)
    const scrollToSlideIndex = (targetIndex) => {
      const slides = carouselTrack.querySelectorAll('.pack-carousel-slide');
      if (targetIndex < 0) targetIndex = 0;
      if (targetIndex >= slides.length) targetIndex = slides.length - 1;

      const targetSlide = slides[targetIndex];
      const centerPosition = targetSlide.offsetLeft - (carouselTrack.clientWidth / 2) + (targetSlide.offsetWidth / 2);

      carouselTrack.scrollTo({ left: centerPosition, behavior: 'smooth' });
    };

    // Calculate current index based on center position
    const getCurrentIndex = () => {
       const centerPoint = carouselTrack.scrollLeft + (carouselTrack.clientWidth / 2);
       const slides = carouselTrack.querySelectorAll('.pack-carousel-slide');
       let closest = 0, minDist = Infinity;
       slides.forEach((slide, i) => {
          const dist = Math.abs(centerPoint - (slide.offsetLeft + slide.offsetWidth/2));
          if(dist < minDist) { minDist = dist; closest = i; }
       });
       return closest;
    };

    // Listeners
    if(prevArrow) prevArrow.addEventListener('click', () => scrollToSlideIndex(getCurrentIndex() - 1));
    if(nextArrow) nextArrow.addEventListener('click', () => scrollToSlideIndex(getCurrentIndex() + 1));
    
    thumbs.forEach(t => {
      t.addEventListener('click', () => scrollToSlideIndex(parseInt(t.dataset.index)));
    });

    // Scroll Sync
    carouselTrack.addEventListener('scroll', () => {
      const index = getCurrentIndex();
      
      // Update Thumbs
      thumbs.forEach((t, i) => t.classList.toggle('active', i === index));
      
      // Update Arrows
      if(prevArrow) {
        if (carouselTrack.scrollLeft <= 10) prevArrow.classList.add('disabled');
        else prevArrow.classList.remove('disabled');
      }
      if(nextArrow) {
        if (carouselTrack.scrollLeft + carouselTrack.offsetWidth >= carouselTrack.scrollWidth - 10) nextArrow.classList.add('disabled');
        else nextArrow.classList.remove('disabled');
      }
    });
    
    // Init check
    carouselTrack.dispatchEvent(new Event('scroll'));
  }